/**
 * The blueprint §5 field table. English names are canonical in the schema;
 * Persian is what the UI shows. This mapping exists nowhere else in the repo —
 * the API stores `label_en`/`label_fa` for *terms*, not for *fields*.
 */
export interface FieldLabel {
  fa: string;
  en: string;
}

export const fieldLabels = {
  id: { fa: "شناسهٔ یکتا اثر", en: "Artwork ID" },
  inventory_code: { fa: "کد اموالی", en: "Inventory code" },
  title: { fa: "عنوان اثر", en: "Artwork Title" },
  artist: { fa: "نام هنرمند", en: "Artist Name" },
  type: { fa: "نوع اثر", en: "Artwork Type" },
  subtype: { fa: "زیرنوع", en: "Subtype" },
  year: { fa: "سال خلق", en: "Creation Year" },
  dimensions: { fa: "ابعاد", en: "Dimensions" },
  artworkDimensions: { fa: "ابعاد اثر", en: "Artwork" },
  frameDimensions: { fa: "ابعاد قاب", en: "Frame" },
  width: { fa: "عرض", en: "Width" },
  height: { fa: "ارتفاع", en: "Height" },
  depth: { fa: "عمق", en: "Depth" },
  is_life_size: { fa: "اندازهٔ طبیعی", en: "Life-size" },
  edition: { fa: "نسخه / چاپ", en: "Edition" },
  edition_number: { fa: "شمارهٔ نسخه", en: "Edition number" },
  edition_size: { fa: "تیراژ", en: "Edition size" },
  parts: { fa: "اجزاء / پانل‌ها", en: "Parts / panels" },
  part_label: { fa: "برچسب جزء", en: "Part label" },
  display_name: { fa: "نام نمایشی", en: "Display name" },
  public_slug: { fa: "نامک صفحه", en: "Public slug" },
  catalog_theme: { fa: "پوسته", en: "Theme" },
  mediums: { fa: "مدیوم / مواد", en: "Medium / Materials" },
  style: { fa: "سبک / مکتب", en: "Style / Movement" },
  curatorial_notes: { fa: "یادداشت کیوریتوری", en: "Curatorial notes" },
  ownership_status: { fa: "وضعیت مالکیت", en: "Ownership Status" },
  valuation: { fa: "قیمت / ارزش", en: "Price / Valuation" },
  price_asking: { fa: "قیمت پیشنهادی", en: "Asking price" },
  price_sold: { fa: "قیمت فروش", en: "Sold" },
  price_estimate: { fa: "برآورد", en: "Estimate" },
  currency: { fa: "واحد پول", en: "Currency" },
  condition_status: { fa: "وضعیت اثر", en: "Condition Status" },
  condition_notes: { fa: "شرح وضعیت", en: "Condition notes" },
  condition_files: { fa: "مستندات وضعیت", en: "Condition report files" },
  provenance_text: { fa: "منشأ اثر", en: "Provenance" },
  provenance_confidence: { fa: "میزان اطمینان", en: "Confidence" },
  authenticity: { fa: "اصالت / گواهی", en: "Authenticity / Certificate" },
  authenticity_notes: { fa: "یادداشت اصالت", en: "Authenticity notes" },
  authenticity_files: { fa: "مدارک / گواهی", en: "Evidence / Certificates" },
  primary_media: { fa: "تصویر اصلی", en: "Primary Image" },
  rights: { fa: "حقوق و مجوز", en: "Rights / Licence" },
  rights_note: { fa: "شرح حقوق", en: "Rights note" },
  access_level: { fa: "سطح دسترسی", en: "Access level" },
  created_at: { fa: "تاریخ ثبت", en: "Created" },
  updated_at: { fa: "آخرین ویرایش", en: "Updated" },
} as const satisfies Record<string, FieldLabel>;
